export default __webpack_public_path__ + "static/media/hht1_song_15.9e827987.png";